/**
 * Each of these values is matched up to a value in @see DesignChannelName.
 *
 * @note These values should match the values of the `SessionType` enum in the AppVersioningService repository.
 */
export enum DesignChannelType {
  email = 'email',
  facebook = 'facebook',
  instagram = 'instagram',
  mobile = 'mobile',
  other = 'other',
  sms = 'sms-text',
  socialChat = 'social-chat',
  twitter = 'twitter',
  voice = 'voice',
  webChat = 'web-chat',
  whatsApp = 'whatsapp'
}
